import { createSlice } from "@reduxjs/toolkit";
// Types
import Reducers from "types/Reducers";

interface IState {
  mounted: boolean;
  playerData: {
    firstname: string;
    lastname: string;
    email: string;
    birthyear: string;
  } | null;
};

const initialState:IState = {
  mounted: false,
  playerData: null,
};

const slice = createSlice({
  name: Reducers.Rokt,
  initialState,
  reducers: {
    setMounted: (state) => {
      state.mounted = true;
    },
    setPlayerData: (state, action) => {
      state.playerData = action.payload;
    },
    setInitialState: (state) => {
      state = initialState;
    }
  },
});

export const {
  setMounted,
  setPlayerData,
  setInitialState
} = slice.actions;

export default slice.reducer;
